@if (showClassesChanged) {
  <div class="top-5-summary-container">
    <h4>Most Score Class Changes</h4>
    @if (classesChanged && classesChanged.length > 0) {
      <table>
        <thead>
          <th>User</th>
          <th>Case</th>
          <th>Classes Changed</th>
          <th>Run Count</th>
          <th>Open Case</th>
          <th>Case History</th>
        </thead>
        <tbody>
          @for (clss of classesChanged; track clss) {
            <tr>
              <td>{{ clss.UserName }}</td>
              <td class="clickable" (click)="viewHistory($event, clss)">
                {{ clss.ClientName }}
              </td>
              <td class="clickable" (click)="viewHistory($event, clss)">
                {{ clss.Changes }}
              </td>
              <td>{{ clss.RunCount }}</td>
              <td class="text-center">
                <button
                  type="button"
                  mat-icon-button
                  matTooltip="Open Case"
                  class="pull-right"
                  color="primary"
                  (click)="viewCase($event, clss)"
                >
                  <mat-icon>work</mat-icon>
                </button>
              </td>
              <td class="text-center">
                <button
                  type="button"
                  mat-icon-button
                  matTooltip="View Case History"
                  class="pull-right"
                  color="warn"
                  (click)="viewHistory($event, clss)"
                >
                  <mat-icon>history</mat-icon>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="no-chart-data"> No Data for selected filters </div>
    }
    <ngx-loading
      [show]="loading"
      [config]="{
        fullScreenBackdrop: false,
      }"
    />
  </div>
}
